import image1 from "../../../assets/DhellServicesImages/11.jpg";
import image2 from "../../../assets/DhellServicesImages/16.jpg";
import image3 from "../../../assets/DhellServicesImages/19.jpg";
import image4 from "../../../assets/DhellServicesImages/18.jpg";
import image5 from "../../../assets/DhellServicesImages/24.jpg";
import image6 from "../../../assets/DhellServicesImages/26.jpg";
import image7 from "../../../assets/DhellServicesImages/5.jpg";
import image8 from "../../../assets/DhellServicesImages/6.jpg";
import image9 from "../../../assets/DhellServicesImages/4.jpg";
import image10 from "../../../assets/DhellServicesImages/3.jpg";
import image11 from "../../../assets/DhellServicesImages/8.jpg";
import image12 from "../../../assets/DhellServicesImages/10.jpg";

export const StaticServicesData = [
    { title: "تحليل السلوك التطبقي ABA", image: image6 },
    { title: "العلاج الوظيفي", image: image5 },
    { title: "العلاج الطبيعي", image: image4 },
    { title: "اضطراب فرط الحركة وتشتت الانتباه", image: image3 },
    { title: "النطق والتخاطب", image: image2 },
    { title: "التقييم الشخصي", image: image1 },
    { title: "برامج ظل", image: image12 },
    { title: "دورات ظل", image: image11 },
    { title: "ظلك الخاص", image: image10 },
    { title: "معلم ظل", image: image9 },
    { title: "التدخلات الأكاديمية", image: image8 },
    { title: "تأهيل وزراعة القوقعه", image: image7 },
];